import type {
    GetCommerceAddressRegionsRequest,
    GetCommerceAddressRegionsResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const getCommerceAddressRegionsOperation = defineCommerceOperation<
    GetCommerceAddressRegionsRequest,
    GetCommerceAddressRegionsResponse
>("commerce.checkout.address-regions.get");
